<template>
	<CDropdown
		inNav
		class="c-header-nav-items"
		placement="bottom-end"
		add-menu-classes="pt-0">
		<template #toggler>
			<CHeaderNavLink>
				<div class="position-relative d-inline-block">
					<CButton variant="ghost"type="reset" size="sm" color="dark" @click="loadNotifications">
						<CIcon name="cil-bell" size="lg"/>
					</CButton>
					<CBadge
						v-if="numberOfUnreadNotifications > 0"
						color="danger"
						shape="pill"
						class="position-absolute top-0 start-100 translate-middle">
						{{ numberOfUnreadNotifications }}
					</CBadge>
				</div>
			</CHeaderNavLink>
		</template>
		<CDropdownHeader tag="div" class="text-center" color="light">
			<strong>Obvestila</strong>
		</CDropdownHeader>
		<CDropdownItem v-if="notificationsListProps.errorText !== ''" disabled>{{ notificationsListProps.errorText }}</CDropdownItem>
		<CDropdownItem v-else-if="notificationsListProps.totalItems === 0" disabled>Ni obvestil</CDropdownItem>
		<CDropdownItem v-else  @click.native.capture.stop="notificationClickAction(notification)" placement="bottom-end" class="align-items-start " v-for="notification in notificationsListProps.items" :key="notification.id">
		<div style="min-width: 19rem; max-width: 19rem;">
			<div class="d-flex w-100 justify-content-between">
				<div class="position-relative d-inline-block">
					<h6 class="mb-1"><b>{{ notification.title }}</b></h6>
				</div>
				<small class="text-muted">
					<span v-if="!notification.viewed_record" class="ml-1 rounded-circle bg-danger d-inline-block" style="width: 7px; height: 7px;"></span>
					{{ notification.created_at | viewDate }}
				</small>
			</div>
			<div style="white-space: normal; word-break: break-word;">
				<span class="mb-1">{{ notification.content }}</span>
			</div>
		</div>
		</CDropdownItem>
		<div v-if="notificationsListProps.totalItems > notificationsListProps.itemsPerPage" class="text-center" color="light">
			<CPagination
				align="center"
				size="sm"
				:active-page.sync="notificationsListProps.currentPage"
				:pages="notificationsListProps.lastPage"
				@update:activePage="loadNotifications"/>
		</div>
		<vue-loading :active.sync="notificationsListProps.isLoading" :is-full-page="false"/>
	</CDropdown>
</template>

<script>
import { NOTIFICATIONS_LIST_FILTERED, NOTIFICATION_SET_VIEWED } from "@/store/actions/notifications";
import fbApp from "@/firebase";
import { getDatabase, ref, onValue, set } from "firebase/database";

const db = getDatabase(fbApp);
const notificationsRefresh = ref(db, 'notifications');

export default {
	name: 'TheHeaderDropdownNotifications',
	components: {
	},
	props: {
	},
	data () {
		return { 
			numberOfUnreadNotifications: 0,
			notificationsListProps: {
				currentPage: 1,
				itemsPerPage: 10,
				lastPage: 0,
				totalItems: 0,
				isLoading: false,
				errorText: '',
				items: []
			},
		}
	},
	computed: {
	},
	methods: {
		loadNotifications: function () {
			this.notificationsListProps.isLoading = true;
			this.$store.dispatch(NOTIFICATIONS_LIST_FILTERED, { props: this.notificationsListProps })
				.then((responseData) => {
					this.notificationsListProps.isLoading = false;
					this.notificationsListProps.items = responseData.notificationsPagination.data
					this.notificationsListProps.totalItems = responseData.notificationsPagination.total;
					this.notificationsListProps.currentPage = responseData.notificationsPagination.current_page;
					this.notificationsListProps.lastPage = responseData.notificationsPagination.last_page;
					this.numberOfUnreadNotifications = responseData.numberOfUnreadNotifications;
					this.notificationsListProps.errorText = '';
				})
				.catch(error => {
					this.notificationsListProps.isLoading = false;
					this.notificationsListProps.items = [];
					this.notificationsListProps.totalItems = 0;
					this.notificationsListProps.errorText = 'Napaka pri pridobivanju obvestil';
					console.log(error);
				});
		},
		notificationClickAction: function (notification) {
			console.log('notification', notification);
			if (!notification.viewed_record) this.setViewedRecord(notification.id);
			const action = notification.custom_data.action;
			if (action === 'showSpOrder') {
				this.$router.push({
					path: '/narocanjeND/list',
					query: { id: notification.custom_data.spOrderId }
				});
			}
		},
		setViewedRecord: function (notificationId) {
			this.notificationsListProps.isLoading = true;
			this.$store.dispatch(NOTIFICATION_SET_VIEWED, { notification_id: notificationId })
				.then((responseData) => {
					this.loadNotifications();
				})
				.catch(error => {
					this.notificationsListProps.isLoading = false;
					console.error(error);
				});
		},
	},
	created: function () {
		this.loadNotifications();
		let $main = this;
		onValue(notificationsRefresh, (snapshot) => {
			console.log('updated');
			$main.loadNotifications();
		});
	}
}
</script>